import { FC, useEffect } from 'react';
import { Route } from 'react-router-dom';

import { replace } from 'connected-react-router';

import { useDispatch } from 'store/utils';

export const InternalRedirect: FC<{ to: string }> = ({ to }) => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(replace(to));
    }, [dispatch, to]);

    return null;
};

interface InternalRedirectRouteProps {
    from: string;
    to: string;
    exact?: boolean;
}

export const InternalRedirectRoute: FC<InternalRedirectRouteProps> = ({ from, to, exact = true }) => {
    return (
        <Route
            exact={exact}
            path={from}
            render={({ location }) => <InternalRedirect to={`${to}${location.search}`} />}
        />
    );
};
